<template>
  <div class="appendix-bottom">
    <div
      v-for="(link, index) in links"
      :key="index"
      :ref="setItemRef"
      class="link-item-wrapper"
      :style="{ 'transition-delay': index * 0.1 + 's' }"
    >
      <AppendixLinkItem
        :text="link.text"
        :url="link.url"
        :image="link.image"
        :description="link.description"
        :lang="lang"
      />
    </div>
  </div>
</template>

<script>
import AppendixLinkItem from './AppendixLinkItem.vue';
import { mapState } from 'vuex';
import { getLinks } from '@/components/main_pages/skinc/skincData.js';

export default {
  name: 'AppendixBottom',
  components: {
    AppendixLinkItem
  },
  data: function () {
    return {
      observer: null,
      itemRefs: []
    };
  },
  computed: {
    ...mapState('report_list', ['lang']),
    links() {
      return getLinks(this.lang);
    }
  },
  mounted() {
    const options = {
      root: null,
      threshold: 0.2,
      rootMargin: '0px'
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, options);

    this.itemRefs.forEach(item => {
      this.observer.observe(item);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  beforeUpdate() {
    this.itemRefs = [];
  },
  methods: {
    setItemRef(el) {
      if (el) {
        this.itemRefs.push(el);
      }
    }
  }
};
</script>

<style scoped>
.appendix-bottom {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 5vh;
  padding: 0 20px 120px;
}

.link-item-wrapper {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.link-item-wrapper.is-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (max-width: 1200px) {
  .appendix-bottom {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
}

@media (max-width: 992px) {
  .appendix-bottom {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .appendix-bottom {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
